import zeebeModdle from 'zeebe-dmn-moddle/resources/zeebe.json';

/**
 * @type { {
 *   zeebe: any
 * } }
 */
export const commonModdleExtensions = {
  zeebe: zeebeModdle
};